import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Grid, Box } from '@mui/material';
import EditVideoPlayer from './edits/videoplayer/sharedplayer';
import GameService from '../../services/game.service';

const CoachSharedEditVideoPlayer = ({ t }) => {
    const params = useParams();
    const [curTagIndex, setCurTagIndex] = useState(0);
    const [tagList, setTagList] = useState([]);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768); // Consider 768px as the breakpoint for mobile devices
        };

        handleResize(); // Check initial screen size
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        (async () => {
            const pathname = window.location.pathname;

            if (pathname.match(/\/shareedit\//) !== null) {
                try {
                    const verifyRes = await GameService.verifyShareId({ code: params.code });
                    if (!verifyRes || verifyRes.length === 0) {
                        console.error('Share link invalid or expired');
                        return;
                    }
                    const edit = verifyRes[0];
                    const clips = edit.clips || [];
                    clips.forEach((game) => {
                        if (game.away_team_logo) game.away_team_logo = process.env.REACT_APP_S3_URI + game.away_team_logo;
                        if (game.home_team_logo) game.home_team_logo = process.env.REACT_APP_S3_URI + game.home_team_logo;
                    });
                    setTagList(clips);
                } catch (error) {
                    console.error('Error loading shared edit:', error);
                }
            }
        })();
    }, [params.code]);

    return (
        <Grid container spacing={2}>
            <Grid item md={12}>
                <EditVideoPlayer t={t} idx={curTagIndex} tagList={tagList} onChangeClip={setCurTagIndex} drawOpen={false} />
            </Grid>
        </Grid>
    );
};
export default CoachSharedEditVideoPlayer;
